/**
 * @fileoverview Define the boundary between persisted event timestamps and calendar-editor values. All-day values retain their literal calendar day; timed values retain their instant. `EventForm.js` and primary-input loading share these conventions so editing an existing event does not invent a different date. Form all-day ranges and provider event ranges have separate conversion boundaries.
 */

import moment from 'moment-timezone';

// DatePicker uses browser-local calendar dates. All-day dates are not instants.


export function buildAllDayRange(value) {
  const date = moment(value).format('YYYY-MM-DD');
  return { startISO: `${date}T00:00:00.000Z`, endISO: `${date}T23:59:59.999Z` };
}



export /**
 * All-day source values describe calendar dates, while timed values describe instants. Preserve that distinction when loading a form; converting an all-day source as an instant first can change the selected day.
 */
function eventFormDate(value, allDay) {
  return allDay ? moment(String(value).slice(0, 10), 'YYYY-MM-DD').toISOString() : new Date(value).toISOString();
}
